<script>
import Layout from "../layouts/main";
import PageHeader from "../components/page-header";
import axios from "axios";
import { VueLoading } from "vue-loading-template";
import {
  ValidationObserver,
  ValidationProvider,
  localize,
  extend,
} from "vee-validate";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// ルール設定
import * as rules from "vee-validate/dist/rules";
for (let rule in rules) {
  extend(rule, rules[rule]);
}
// 日本語化
import ja from "vee-validate/dist/locale/ja";
localize("ja", ja);

extend("seedPair", {
  params: ["seed_block", "seed_no"],
  message: "シードは空、または両方入力してください",
  validate(value, { seed_block, seed_no }) {
    // 両方空、または両方入力されている場合のみOK
    const isBlockEmpty = !seed_block || seed_block === "";
    const isNoEmpty = !seed_no || seed_no === "";
    return (isBlockEmpty && isNoEmpty) || (!isBlockEmpty && !isNoEmpty);
  },
});

export default {
  components: {
    Layout,
    PageHeader,
    VueLoading,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      initSelecting: false, // 追加：編集時の初期選択フラグ（true の間は name/no 等を上書きしない）
      search_game_info_id: "", // 検索用のGameInfo ID
      search_school_code: "", // 検索用の学校コード
      search_bye: "0", // 検索用の不戦勝
      byeList: [
        { value: "0", text: "Entry" },
        { value: "1", text: "Bye" },
      ],
      // 性別選択肢
      sexOptions: [
        { value: "", text: "" },
        { value: 1, text: "男子" },
        { value: 2, text: "女子" },
      ],
      game_info_id: "", // 追加・編集用のGameInfo ID
      school_code: "", // 追加・編集用の学校コード
      tableData: [],
      title: "エントリー", // タイトルを修正
      items: [
        {
          text: "Entry",
          href: "/",
        },
        {
          text: "エントリー",
          active: true,
        },
      ],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      seed_block: "", // シードブロック
      seed_no: "", // シード番号
      bye: "", // 不戦勝
      player_id1: "", // プレイヤーID1
      player_id2: "", // プレイヤーID2
      selectedPlayer1: "", // 選手1
      selectedPlayer2: "", // 選手2
      player_no1: "", // 選手番号1
      player_no2: "", // 選手番号2
      player_sex1: "", // 選手性別1
      player_sex2: "", // 選手性別2
      player_school_year1: "", // 選手学年1
      player_school_year2: "", // 選手学年2
      player_rank1: "", // 選手ランク1
      player_rank2: "", // 選手ランク2
      id: null,
      errors: [],
      selectAll: false,
      filterItems: [],
      filter: null,
      filterOn: ["school_code", "school_name", "players", "seed"],
      fields: [
        {
          key: "checkbox",
          label: "",
          sortable: false,
        },
        {
          key: "school_code",
          label: "学校コード",
          sortable: true,
          tdClass: "minWidth100",
        },
        {
          key: "school_name",
          label: "学校名",
          sortable: true,
          tdClass: "minWidth150",
        },
        {
          key: "players", // 選手情報をまとめたカスタム列
          label: "選手情報",
          sortable: false,
          tdClass: "minWidth300",
        },
        {
          key: "seed",
          label: "シード", // シード列を追加
          sortable: true,
          tdClass: "minWidth100",
        },
        { key: "actions", label: "", sortable: false, tdClass: "minWidth100" },
      ],
      loading: false,
      mode: "list",
      gameInfos: [], // ゲーム情報一覧を格納
      schoolList: [], // 学校一覧を格納
      players: [], // プレイヤー一覧を格納
      isGameInfoFixed: false, // 追加: 選択中のGameInfoが確定済みか
      currentPlayerCount: 2,
    };
  },
  mounted() {
    // VuexからGameInfoIdを取得
    this.search_game_info_id = this.$store.state.gameInfoId;

    let roles = this.$store.getters.roles;
    if (roles == "admin") {
      this.getUser("admin");
    } else if (roles == "user") {
      this.getUser("user");
      this.search_school_code = this.$store.getters.schoolCode;
    } else {
      window.location.href = "/";
      return;
    }
    this.searchItems();
  },
  computed: {
    // filteredPlayers: 入力された学校コードでプレイヤーを絞り込む
    filteredPlayers() {
      if (!this.school_code) {
        // 学校コードが未入力の場合、すべてのプレイヤーを返す
        return this.players;
      }
      // 学校コードで絞り込む
      return this.players.filter(player => player.school_code === this.school_code);
    },
    displayedFields() {
      if (this.search_bye === "1") {
        return [
          {
            key: "checkbox",
            label: "",
            sortable: false,
          },
          {
            key: "seed",
            label: "Bye",
            sortable: true,
            tdClass: "minWidth100",
          },
          { key: "actions", label: "", sortable: false, tdClass: "minWidth100" },
        ];
      }
      return this.fields; // 通常のfieldsを表示
    },
    rows() {
      return this.filterItems.length;
    },
    showPlayer2() {
      return this.search_bye == "0" && Number(this.currentPlayerCount) !== 1;
    },
  },
  methods: {
    // 検索
    searchItems() {
      this.loading = true;
      axios
        .get("/api/entry", {
          params: {
            game_info_id: this.search_game_info_id,
            school_code: this.search_school_code || null, // 空白の場合はnullを送信
            bye: this.search_bye || null, // 空白の場合はnullを送信
          },
        })
        .then((response) => {
          this.loading = false;

          // エントリー一覧データを設定
          this.tableData = response.data.entries.map((item) => {
            // 選手情報を1つの文字列にまとめる
            const player1 = item.player_name1 ? `${item.player_name1} ${item.player_school_year1 ?? ""}年 ${item.player_sex1 === 1 ? "男子" : item.player_sex1 === 2 ? "女子" : ""} 校内順位:${item.player_rank1 ?? ""}` : "";
            const player2 = item.player_name2 ? `${item.player_name2} ${item.player_school_year2 ?? ""}年 ${item.player_sex2 === 1 ? "男子" : item.player_sex2 === 2 ? "女子" : ""} 校内順位:${item.player_rank2 ?? ""}` : "";
            return {
              ...item,
              bye: item.bye === 1,
              players: `${player1} ${player2}`.trim(), // ←ここを追加
            };
          });

          // GameInfoデータを設定
          this.gameInfos = [
            { value: "", text: "" }, // 空白の選択肢を追加
            ...response.data.gameInfos.map((gameInfo) => {
              return {
                value: gameInfo.id,
                text: `${gameInfo.game_name} (${gameInfo.event_name})`,
                player_count: gameInfo.player_count,
              };
            }),
          ];

          // 選択中の game_info が確定(fix)かどうかを判定してフラグを保持
          // response.data.gameInfos に元のデータがある前提（fix フィールドを期待）
          const matched = response.data.gameInfos.find(
            (g) => String(g.id) === String(this.search_game_info_id)
          );
          this.isGameInfoFixed = matched ? !!matched.fix : false;
          this.currentPlayerCount = matched ? Number(matched.player_count || 2) : 2;

          // 存在チェック
          const exists = this.gameInfos.some(
            (gameInfo) => gameInfo.value === this.search_game_info_id
          );
          if (!exists || this.search_game_info_id === "") {
            window.location.href = "/";
          }

          // Schoolデータを設定
          this.schoolList = [
            { value: "", text: "" }, // 空白の選択肢を追加
            ...response.data.schools.map((school) => {
              return {
                value: school.school_code,
                text: `${school.school_code} : ${school.school_name}`,
              };
            }),
          ];

          // Playerデータを設定
          this.players = [
            { value: "", text: "" }, // 空白の選択肢を追加
            ...response.data.players.map((player) => {
              return {
                value: player.id,
                text: `${player.name} (学年：${player.school_year ?? ""}, 性別：${player.sex === 1 ? "男子" : player.sex === 2 ? "女子" : ""}, 校内順位：${player.rank ?? ""})`,
                id: player.id,
                school_code: player.school_code,
                no: player.no,
                name: player.name,
                sex: player.sex,
                school_year: player.school_year,
                rank: player.rank,
              };
            }),
          ];

          this.filterItems = this.tableData;
          this.selectAll = false;
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 削除
    deleteItems() {
      if (this.isGameInfoFixed) {
        this.$toasted.error("確定済みの大会情報では削除できません");
        return;
      }
      this.loading = true;
      let list = this.tableData.filter((item) => item.selected);
      let ids = [];
      list.forEach((item) => {
        ids.push(item.id);
      });
      axios
        .post("/api/entry/delete", {
          ids: ids,
        })
        .then((response) => {
          this.loading = false;
          this.searchItems();
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    // 追加
    add() {
      if (this.isGameInfoFixed) {
        this.$toasted.error("確定済みの大会情報では追加できません");
        return;
      }
      this.mode = "add";
      this.id = "new";
      this.game_info_id = this.search_game_info_id;
      this.school_code = this.search_school_code;
      this.seed_block = "";
      this.seed_no = "";
      this.player_id1 = "";
      this.player_id2 = "";
      this.selectedPlayer1 = "";
      this.selectedPlayer2 = "";
      this.player_no1 = "";
      this.player_no2 = "";
      this.player_name1 = "";
      this.player_name2 = "";
      this.player_sex1 = "";
      this.player_sex2 = "";
      this.player_school_year1 = "";
      this.player_school_year2 = "";
      this.player_rank1 = "";
      this.player_rank2 = "";
      this.bye = null;
      if (this.search_bye == "1") {
        this.school_code = "";
        this.bye = 1;
      }
      if (!this.showPlayer2) {
        this.selectedPlayer2 = "";
        this.player_id2 = "";
        this.player_no2 = "";
        this.player_name2 = "";
        this.player_sex2 = "";
        this.player_school_year2 = "";
        this.player_rank2 = "";
      }
    },
    // 編集
    edit(item) {
      if (this.isGameInfoFixed) {
        this.$toasted.error("確定済みの大会情報では編集できません");
        return;
      }
      this.mode = "edit";
      this.id = item.id;
      this.game_info_id = item.game_info_id;
      this.school_code = item.school_code;
      this.seed_block = item.seed_block;
      this.seed_no = item.seed_no;
      this.player_id1 = item.player_id1;
      this.player_id2 = item.player_id2;
      this.player_no1 = item.player_no1;
      this.player_no2 = item.player_no2;
      this.player_name1 = item.player_name1;
      this.player_name2 = item.player_name2;
      this.player_sex1 = item.player_sex1;
      this.player_sex2 = item.player_sex2;
      this.player_school_year1 = item.player_school_year1;
      this.player_school_year2 = item.player_school_year2;
      this.player_rank1 = item.player_rank1;
      this.player_rank2 = item.player_rank2;
      this.bye = null;
      if (this.search_bye == "1") {
        this.school_code = "";
        this.bye = 1;
      }
      if (!this.showPlayer2) {
        this.selectedPlayer2 = "";
        this.player_id2 = "";
        this.player_no2 = "";
        this.player_name2 = "";
        this.player_sex2 = "";
        this.player_school_year2 = "";
        this.player_rank2 = "";
      }
      // 初期選択フェーズを有効にして selectedPlayer を設定（この間は name/no 等を上書きしない）
      this.initSelecting = true;
      this.$nextTick(() => {
        // school_codeの変更後に選手を設定
        this.selectedPlayer1 = this.players.find(player => player.value === item.player_id1) || "";
        this.selectedPlayer2 = this.showPlayer2
          ? (this.players.find(player => player.value === item.player_id2) || "")
          : "";
        // 次の tick で初期選択完了とする（ウォッチャーが以降は上書きする）
        this.$nextTick(() => { this.initSelecting = false; });
      });
    },
    // 確定
    submit() {
      // Bye時に両方空の場合はエラー
      if (this.search_bye == "1") {
        const hasSeedBlock = this.seed_block !== null && this.seed_block !== undefined && String(this.seed_block).trim() !== "";
        const hasSeedNo = this.seed_no !== null && this.seed_no !== undefined && String(this.seed_no).trim() !== "";
        if (!hasSeedBlock && !hasSeedNo) {
          this.$toasted.error("Bye（ブロック）かBye（No）のどちらかを入力してください");
          return;
        }
      }

      let formData = new FormData();

      if (!this.showPlayer2) {
        this.selectedPlayer2 = "";
        this.player_id2 = "";
        this.player_no2 = "";
        this.player_name2 = "";
        this.player_sex2 = "";
        this.player_school_year2 = "";
        this.player_rank2 = "";
      }

      // 必要な値を追加
      formData.append("id", this.id);
      formData.append("game_info_id", this.game_info_id || ""); // 空文字列を送信
      formData.append("school_code", this.school_code || ""); // 空文字列を送信
      // シード（ブロック）とシード（No）は空の場合に追加しない
      if (this.seed_block) {
        formData.append("seed_block", this.seed_block);
      }
      if (this.seed_no) {
        formData.append("seed_no", this.seed_no);
      }
      if (this.bye) {
        formData.append("bye", this.bye);
      }
      // formData.append("player_id1", this.selectedPlayer1 ? this.selectedPlayer1.value : ""); // 選手1のID
      // formData.append("player_id2", this.selectedPlayer2 ? this.selectedPlayer2.value : ""); // 選手2のID
      formData.append("player_id1", this.player_id1 || ""); // 選手1のID
      formData.append("player_id2", this.player_id2 || ""); // 選手2のID
      formData.append("player_no1", this.player_no1 || ""); // 選手番号1
      formData.append("player_no2", this.player_no2 || ""); // 選手番号2
      formData.append("player_name1", this.player_name1 || ""); // 選手名前1
      formData.append("player_name2", this.player_name2 || ""); // 選手名前2
      formData.append("player_sex1", this.player_sex1 || ""); // 選手性別1
      formData.append("player_sex2", this.player_sex2 || ""); // 選手性別2
      formData.append("player_school_year1", this.player_school_year1 || ""); // 選手学年1
      formData.append("player_school_year2", this.player_school_year2 || ""); // 選手学年2
      formData.append("player_rank1", this.player_rank1 || ""); // 選手ランク1
      formData.append("player_rank2", this.player_rank2 || ""); // 選手ランク2

      let config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      this.loading = true;
      axios
        .post("/api/entry/update", formData, config)
        .then((res) => {
          this.loading = false;
          this.searchItems();
          this.mode = "list";
        })
        .catch((error) => {
          this.loading = false;
          this.errorProcess(error);
        });
    },
    onFiltered(items) {
      this.filterItems = items;
    },
    formatDate(date) {
      if (!date) return ""; // nullまたはundefinedの場合は空欄を返す
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      return new Date(date).toLocaleDateString("ja-JP", options);
    },
    goToGameInfo() {
      window.location.href = `/game-info`;
    },
  },
  watch: {
    selectAll(newValue) {
      this.filterItems.forEach((item) => {
        item.selected = this.selectAll;
      });
    },
    school_code(newVal, oldVal) {
      // 学校コードが変更されたら選手1・選手2を空にする
      this.selectedPlayer1 = "";
      this.selectedPlayer2 = "";
    },
    // 選手選択が変わったら Entry 側のフィールドを上書き
    selectedPlayer1(newVal) {
      this.player_id1 = this.selectedPlayer1 ? this.selectedPlayer1.value : "";
      if (this.initSelecting) {
        // 初期選択フェーズ中は上書きしない
        return;
      }
      // player_id1を元に、players配列から選手情報を取得して他のフィールドを更新
      const player = this.players.find(p => p.id === this.player_id1);
      if (player) {
        this.player_no1 = player.player_no || "";
        this.player_name1 = player.name || "";
        this.player_sex1 = player.sex || "";
        this.player_school_year1 = player.school_year || "";
        this.player_rank1 = player.rank || "";
      } else {
        this.player_no1 = "";
        this.player_name1 = "";
        this.player_sex1 = "";
        this.player_school_year1 = "";
        this.player_rank1 = "";
      }
    },
    selectedPlayer2(newVal) {
      this.player_id2 = this.selectedPlayer2 ? this.selectedPlayer2.value : "";
      if (this.initSelecting) {
        // 初期選択フェーズ中は上書きしない
        return;
      }
      // player_id2を元に、players配列から選手情報を取得して他のフィールドを更新
      const player = this.players.find(p => p.id === this.player_id2);
      if (player) {
        this.player_no2 = player.player_no || "";
        this.player_name2 = player.name || "";
        this.player_sex2 = player.sex || "";
        this.player_school_year2 = player.school_year || "";
        this.player_rank2 = player.rank || "";
      } else {
        this.player_no2 = "";
        this.player_name2 = "";
        this.player_sex2 = "";
        this.player_school_year2 = "";
        this.player_rank2 = "";
      }
    },
  },
};
</script>

<style>
.minWidth100 {
  min-width: 100px;
  word-break: break-all;
}

.minWidth200 {
  min-width: 200px;
  word-break: break-all;
}

.minWidth150 {
  min-width: 150px;
  word-break: break-all;
}

.minWidth300 {
  min-width: 300px;
  word-break: break-all;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!-- リスト -->
    <div class="row" v-if="mode == 'list'">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2 me-2">
              <div class="col-sm-12 col-md-6">
                <b-form-group label="大会情報" label-cols-sm="3">
                  <b-form-select v-model="search_game_info_id" :options="gameInfos" @change="searchItems"
                    class="form-select" disabled></b-form-select>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-3">
                <b-form-group label="学校" label-cols-sm="3">
                  <b-form-select v-model="search_school_code" :options="schoolList" @change="searchItems"
                    class="form-select" :disabled="$store.getters.roles === 'user'"></b-form-select>
                </b-form-group>
              </div>
              <div class="col-sm-12 col-md-3" v-if="$store.getters.roles !== 'user'">
                <b-form-group label="Bye" label-cols-sm="3">
                  <b-form-select v-model="search_bye" :options="byeList" @change="searchItems"
                    class="form-select"></b-form-select>
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <label class="ms-1 mb-0 pb-0">件数：{{ filterItems.length }}</label>
            </div>
            <hr class="mt-1 pt-0" />
            <div class="row mt-3">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    表示&nbsp;
                    <b-form-select v-model="perPage" size="sm" class="form-select form-select-sm"
                      :options="pageOptions"></b-form-select>&nbsp;行
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div class="text-md-end">
                  <label class="d-inline-flex align-items-center" style="white-space: nowrap">
                    フィルタ:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control ms-2"></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <b-table striped hover :items="tableData" :fields="displayedFields" responsive="sm" :per-page="perPage"
                :current-page="currentPage" :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                <template v-slot:head(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="selectAll">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(checkbox)="{ item }">
                  <b-form-group>
                    <b-form-checkbox plain v-model="item.selected" class="mr-1">
                    </b-form-checkbox>
                  </b-form-group>
                </template>
                <template v-slot:cell(players)="{ item }">
                  <div>
                    <!-- 選手1の情報を表示（player1が存在する場合のみ） -->
                    <div v-if="item.player_name1">
                      <strong>選手１：</strong>
                      {{ item.player_name1 }}
                      (学年：{{ item.player_school_year1 }}年, 性別：
                      {{ item.player_sex1 === 1 ? '男子' : (item.player_sex1 === 2 ? '女子' : '') }},
                      校内順位： {{ item.player_rank1 }})
                    </div>
                    <!-- 選手2の情報を表示（player2が存在する場合のみ） -->
                    <div v-if="showPlayer2 && item.player_name2">
                      <strong>選手２：</strong>
                      {{ item.player_name2 }}
                      (学年：{{ item.player_school_year2 }}年, 性別：
                      {{ item.player_sex2 === 1 ? '男子' : (item.player_sex2 === 2 ? '女子' : '') }},
                      校内順位： {{ item.player_rank2 }})
                    </div>
                  </div>
                </template>
                <template v-slot:cell(seed)="{ item }">
                  <span v-if="item.seed_block && item.seed_no">
                    {{ item.seed_block }} - {{ item.seed_no }}
                  </span>
                  <span v-else-if="item.seed_block">
                    {{ item.seed_block }} - *
                  </span>
                  <span v-else-if="item.seed_no">
                    * - {{ item.seed_no }}
                  </span>
                </template>
                <template v-slot:cell(actions)="{ item }">
                  <span>
                    <button class="btn btn-sm btn-outline-primary" @click="edit(item)">
                      編集
                    </button>
                  </span>
                </template>
              </b-table>
            </div>
            <div class="row mb-3">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-12 mb-3">
                <div id="tickets-table_filter" class="text-md-end">
                  <button class="btn btn-danger me-2" type="button" v-b-modal.modal-delete>
                    削除
                  </button>
                  <button class="btn btn-primary me-2" type="button" @click="add">
                    追加
                  </button>
                  <button class="btn btn-primary" @click="goToGameInfo">戻る</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- 追加・編集 -->
    <div class="row" v-if="mode == 'add' || mode == 'edit'">
      <div class="col-lg-10">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">
              {{ mode == "add" ? "新規登録" : "編集" }}
            </h4>
            <ValidationObserver ref="obs" v-slot="ObserverProps">
              <b-form>
                <div class="row">
                  <div class="col-lg-12">
                    <b-form-group label="大会情報" label-cols-sm="3">
                      <ValidationProvider name="大会情報" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-select plain v-model="game_info_id" :options="gameInfos" disabled></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="学校コード" label-cols-sm="3" v-if="search_bye == '0'">
                      <ValidationProvider name="学校コード" :rules="{ required: true }">
                        <div slot-scope="ProviderProps">
                          <b-form-select v-model="school_code" :options="schoolList" placeholder="学校を選択"
                            class="form-select" style="width: 200px"
                            :disabled="$store.getters.roles === 'user'"></b-form-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group label="選手1" label-cols-sm="3" class="mb-3" v-if="search_bye == '0'">
                      <ValidationProvider name="選手1" :rules="{ required: false }">
                        <div slot-scope="ProviderProps">
                          <v-select v-model="selectedPlayer1" :options="filteredPlayers" label="text"></v-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                      <!-- 変更後：1行にまとめる -->
                      <div class="d-flex align-items-end flex-wrap">
                        <div class="me-3" style="min-width:300px;">
                          <ValidationProvider name="選手1の名前" :rules="{ required: true }" v-slot="{ errors }">
                            <label for="name1" class="mt-1">名前</label>
                            <b-form-input id="name1" type="text" v-model="player_name1" style="width:100%"
                              autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ errors[0] }}</p>
                          </ValidationProvider>
                        </div>
                        <div class="me-3" style="min-width:100px;">
                          <!-- 学年は必須 -->
                          <ValidationProvider name="選手1の学年" :rules="{ required: true, regex: /^[0-9]{1,2}$/ }"
                            v-slot="{ errors }">
                            <label for="school_year1">学年</label>
                            <b-form-input id="school_year1" type="text" v-model="player_school_year1" placeholder="学年"
                              style="width:100%" autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ errors[0] }}</p>
                          </ValidationProvider>
                        </div>
                        <div class="me-3" style="min-width:150px;">
                          <ValidationProvider name="選手1の性別" :rules="{ required: false }" v-slot="{ errors }">
                            <label for="sex1">性別</label>
                            <b-form-select id="sex1" v-model="player_sex1" :options="sexOptions" placeholder="性別"
                              class="form-select" style="width:100%"></b-form-select>
                            <p class="text-danger mb-2">{{ errors[0] }}</p>
                          </ValidationProvider>
                        </div>
                        <div style="min-width:100px;">
                          <ValidationProvider name="選手1の校内順位" :rules="{ regex: /^[0-9]{1,4}$/ }" v-slot="{ errors }">
                            <label for="rank1">校内順位</label>
                            <b-form-input id="rank1" type="text" v-model="player_rank1" placeholder="順位"
                              style="width:100%" autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ errors[0] }}</p>
                          </ValidationProvider>
                        </div>
                      </div>
                    </b-form-group>
                    <b-form-group label="選手2" label-cols-sm="3" v-if="showPlayer2">
                      <ValidationProvider name="選手2" :rules="{ required: false }">
                        <div slot-scope="ProviderProps">
                          <v-select v-model="selectedPlayer2" :options="filteredPlayers" label="text"></v-select>
                          <p class="text-danger mb-2">
                            {{ ProviderProps.errors[0] }}
                          </p>
                        </div>
                      </ValidationProvider>
                      <!-- 変更後：1行にまとめる -->
                      <div class="d-flex align-items-end flex-wrap">
                        <div class="me-3" style="min-width:300px;">
                          <ValidationProvider name="選手2の名前" :rules="{ required: false }" v-slot="{ errors }">
                            <label for="name2" class="mt-1">名前</label>
                            <b-form-input id="name2" type="text" v-model="player_name2" style="width:100%"
                              autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ errors[0] }}</p>
                          </ValidationProvider>
                        </div>
                        <div class="me-3" style="min-width:100px;">
                          <!-- 選手2は氏名が入っていたら学年必須 -->
                          <ValidationProvider name="選手2の学年" :rules="{
                            required: player_name2 ? true : false,
                            regex: /^[0-9]{1,2}$/
                          }" v-slot="{ errors }">
                            <label for="school_year2">学年</label>
                            <b-form-input id="school_year2" type="text" v-model="player_school_year2" placeholder="学年"
                              style="width:100%" autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ errors[0] }}</p>
                          </ValidationProvider>
                        </div>
                        <div class="me-3" style="min-width:150px;">
                          <ValidationProvider name="選手2の性別" :rules="{ required: false }" v-slot="{ errors }">
                            <label for="sex2">性別</label>
                            <b-form-select id="sex2" v-model="player_sex2" :options="sexOptions" placeholder="性別"
                              class="form-select" style="width:100%"></b-form-select>
                            <p class="text-danger mb-2">{{ errors[0] }}</p>
                          </ValidationProvider>
                        </div>
                        <div style="min-width:100px;">
                          <ValidationProvider name="選手2の校内順位" :rules="{ regex: /^[0-9]{1,4}$/ }" v-slot="{ errors }">
                            <label for="rank2">校内順位</label>
                            <b-form-input id="rank2" type="text" v-model="player_rank2" placeholder="順位"
                              style="width:100%" autocomplete="off"></b-form-input>
                            <p class="text-danger mb-2">{{ errors[0] }}</p>
                          </ValidationProvider>
                        </div>
                      </div>
                    </b-form-group>
                    <!-- シード/Bye入力欄 -->
                    <b-form-group v-if="search_bye == '0' && $store.getters.roles === 'admin'" label="シード（ブロック）"
                      label-cols-sm="3">
                      <ValidationProvider name="シード（ブロック）" :rules="{
                        seedPair: [seed_block, seed_no],
                        numeric: true,
                        min_value: 1,
                        max_value: 99
                      }" v-slot="ProviderProps">
                        <b-form-input type="number" style="width: 100px" v-model="seed_block"
                          autocomplete="off"></b-form-input>
                        <p class="text-danger mb-2">
                          {{ ProviderProps.errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group v-if="search_bye == '0' && $store.getters.roles === 'admin'" label="シード（No）"
                      label-cols-sm="3">
                      <ValidationProvider name="シード（No）" :rules="{
                        seedPair: [seed_block, seed_no],
                        numeric: true,
                        min_value: 1,
                        max_value: 99
                      }" v-slot="ProviderProps">
                        <b-form-input type="number" style="width: 100px" v-model="seed_no"
                          autocomplete="off"></b-form-input>
                        <p class="text-danger mb-2">
                          {{ ProviderProps.errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-form-group>

                    <!-- Bye入力欄 -->
                    <b-form-group v-if="search_bye == '1'" label="Bye（ブロック）" label-cols-sm="3">
                      <ValidationProvider name="Bye（ブロック）"
                        :rules="{ numeric: true, min_value: 1, max_value: 99 }" v-slot="ProviderProps">
                        <b-form-input type="number" style="width: 100px" v-model="seed_block"
                          autocomplete="off"></b-form-input>
                        <p class="text-danger mb-2">
                          {{ ProviderProps.errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-form-group>
                    <b-form-group v-if="search_bye == '1'" label="Bye（No）" label-cols-sm="3">
                      <ValidationProvider name="Bye（No）"
                        :rules="{ numeric: true, min_value: 1, max_value: 99 }" v-slot="ProviderProps">
                        <b-form-input type="number" style="width: 100px" v-model="seed_no"
                          autocomplete="off"></b-form-input>
                        <p class="text-danger mb-2">
                          {{ ProviderProps.errors[0] }}
                        </p>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <div class="row mt-2">
                  <div>
                    <b-button class="me-2" variant="primary" :disabled="ObserverProps.invalid"
                      @click="submit">確定</b-button>
                    <b-button variant="primary" @click="mode = 'list'">戻る</b-button>
                  </div>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
    <!-- 削除 -->
    <b-modal id="modal-delete" title="確認" title-class="font-18" @ok="deleteItems">
      <p>選択されたデータを削除してよろしいですか？</p>
    </b-modal>
    <div v-if="loading" class="modal-mask">
      <vue-loading type="spiningDubbles" color="#eee" :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div>
  </Layout>
</template>
